<template>
  <div class="w1200 zhaogu-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
    </div>
    <div class="page-title">我的认购记录</div>

    <!-- 自动跟注状态条（按投注站隔离，设置入口在个人中心 → 我的跟注） -->
    <div class="follow-bar">
      <div class="follow-bar-left">
        <div class="follow-bar-title">
          <i class="el-icon-refresh" />自动跟注
          <el-tag v-if="followShopTotal > 0" type="success" size="mini" effect="dark">
            已跟注 {{ followShopTotal }} 个投注站（其中 {{ followShopEnabledCount }} 个已开启）
          </el-tag>
          <el-tag v-else size="mini" type="info">未跟注任何投注站</el-tag>
        </div>
        <div class="follow-bar-desc">
          跟注是<b>按投注站</b>的：在某个投注站认购过众筹招股后，可开启对该投注站的跟注，
          之后<b>该投注站</b>新发布的众筹招股会自动按设定股数认购，<b>其他投注站发布的不跟</b>。
          每个投注站独立开关与独立股数设置。
        </div>
        <div class="follow-bar-desc">
          受缩币余额、个人认购上限、当期剩余份额约束，不足时当期自动跳过并记录原因。
        </div>
      </div>
      <div class="follow-bar-right">
        <el-button type="primary" size="small" plain icon="el-icon-setting"
          @click="goFollowSetting">我的跟注</el-button>
      </div>
    </div>

    <el-tabs v-model="activeTab" class="zhaogu-tabs">
      <!-- 我的认购 -->
      <el-tab-pane label="我的认购" name="subscribe">
        <el-table v-loading="loading" :data="list" empty-text="暂无认购记录"
          :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="title" label="众筹标题" show-overflow-tooltip></el-table-column>
          <el-table-column prop="issueNumber" label="期号" width="110"></el-table-column>
          <el-table-column label="彩种" width="100">
            <template slot-scope="{ row }">{{ lotteryTypeName(row.lotteryType) }}</template>
          </el-table-column>
          <el-table-column label="每股价格" width="110">
            <template slot-scope="{ row }">{{ money(row.crowdfundingPrice) }} 缩币</template>
          </el-table-column>
          <el-table-column prop="purchaserNumber" label="认购股数" width="100"></el-table-column>
          <el-table-column label="每股分红" width="110">
            <template slot-scope="{ row }">{{ money(row.payablePrice) }} 缩币</template>
          </el-table-column>
          <el-table-column label="应得分红" width="120">
            <template slot-scope="{ row }">{{ money(row.payable) }} 缩币</template>
          </el-table-column>
          <el-table-column prop="bonusStatusIntro" label="派奖状态" width="110"></el-table-column>
          <el-table-column prop="createTime" label="认购时间" width="170"></el-table-column>
          <el-table-column label="操作" width="90" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" @click="goDetail(row.crowdfundingId)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="fenye" v-if="total > 0">
          <el-pagination background layout="prev, pager, next" :total="total"
            :page-size="pageSize" :current-page="pageNum" @current-change="onPage"></el-pagination>
        </div>
      </el-tab-pane>

      <!-- 跟注记录 -->
      <el-tab-pane :label="followTabLabel" name="follow">
        <div class="follow-tip">
          自动跟注每期执行一次，结果如下。余额不足可先充值，份额不足可下期再试；也可随时手动认购。
        </div>
        <el-table v-loading="followLoading" :data="followList" empty-text="暂无跟注记录"
          :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="title" label="众筹标题" show-overflow-tooltip></el-table-column>
          <el-table-column prop="issueNumber" label="期号" width="110"></el-table-column>
          <el-table-column label="彩种" width="100">
            <template slot-scope="{ row }">{{ row.lotteryTypeIntro || lotteryTypeName(row.lotteryType) }}</template>
          </el-table-column>
          <el-table-column label="跟注股数" width="100">
            <template slot-scope="{ row }">
              <span v-if="row.status === 1">{{ row.shares }} 股</span>
              <span v-else class="txt-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="扣减缩币" width="110">
            <template slot-scope="{ row }">
              <span v-if="row.status === 1">{{ money(row.cost) }} 缩币</span>
              <span v-else class="txt-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="结果" width="150">
            <template slot-scope="{ row }">
              <el-tag :type="statusTagType(row.status)" size="mini" effect="dark">
                {{ row.statusIntro || '未知' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="failReason" label="失败原因" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-if="row.status === 1" class="txt-muted">-</span>
              <span v-else>{{ row.failReason || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="跟注时间" width="170"></el-table-column>
          <el-table-column label="操作" width="90" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" @click="goDetail(row.crowdfundingId)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="fenye" v-if="followTotal > 0">
          <el-pagination background layout="prev, pager, next" :total="followTotal"
            :page-size="followPageSize" :current-page="followPageNum"
            @current-change="onFollowPage"></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  bettingShopMySubscribeList,
  crowdfundingFollowShopList,
  crowdfundingFollowMyLogList,
} from "@/api/apply";

const LOTTERY_MAP = {
  '0': '双色球', '1': '大乐透', '2': '福彩3D', '3': '排列3',
  '5': '七乐彩', '6': '7星彩', '7': '排列5', '8': '快乐8',
};

export default {
  name: "MySubscribe",
  data() {
    return {
      activeTab: "subscribe",
      list: [],
      loading: false,
      total: 0,
      pageSize: 10,
      pageNum: 1,
      // 跟注的投注站列表（只读展示，编辑入口在个人中心 → 我的跟注）
      followShopList: [],
      // 跟注记录
      followList: [],
      followLoading: false,
      followTotal: 0,
      followPageSize: 10,
      followPageNum: 1,
    };
  },
  computed: {
    followTabLabel() {
      return this.followTotal > 0 ? "跟注记录(" + this.followTotal + ")" : "跟注记录";
    },
    followShopTotal() {
      return this.followShopList.length;
    },
    followShopEnabledCount() {
      return this.followShopList.filter((s) => Number(s.enabled) === 1).length;
    },
  },
  mounted() {
    this.loadList();
    // 未登录不查跟注数据，避免触发全局登录过期弹窗
    if (this.isLoggedIn()) {
      this.loadFollowShops();
      this.loadFollowLog();
    }
  },
  methods: {
    isLoggedIn() {
      return !!(this.$store && this.$store.state && this.$store.state.vuex_token);
    },
    goBack() {
      this.$router.push("/sttzzbfzx/zhaogu");
    },
    goDetail(id) {
      this.$router.push("/sttzzbfzx/zhaogu/detail/" + id);
    },
    lotteryTypeName(type) {
      return LOTTERY_MAP[type] || type || "-";
    },
    money(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return isNaN(n) ? v : n;
    },
    statusTagType(status) {
      const s = Number(status);
      if (s === 1) return "success";
      if (s === 2) return "danger";   // 余额不足
      if (s === 3) return "warning";  // 份额不足
      return "info";
    },
    // ===== 我的认购 =====
    loadList() {
      this.loading = true;
      bettingShopMySubscribeList({ pageNum: this.pageNum, pageSize: this.pageSize })
        .then((res) => {
          const rows = (res && res.rows) || (res && res.data && res.data.rows) || [];
          const total = (res && res.total) || (res && res.data && res.data.total) || 0;
          this.list = rows;
          this.total = total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onPage(page) {
      this.pageNum = page;
      this.loadList();
    },
    // ===== 跟注的投注站列表（只读） =====
    loadFollowShops() {
      crowdfundingFollowShopList()
        .then((res) => {
          const data = res && res.data !== undefined ? res.data : res;
          const arr = Array.isArray(data) ? data : (data && (data.list || data.rows)) || [];
          this.followShopList = Array.isArray(arr) ? arr : [];
        })
        .catch(() => {
          this.followShopList = [];
        });
    },
    goFollowSetting() {
      this.$router.push("/personalCenter/tzz_bf/crowdfundingFollow");
    },
    // ===== 跟注记录 =====
    loadFollowLog() {
      this.followLoading = true;
      crowdfundingFollowMyLogList({ pageNum: this.followPageNum, pageSize: this.followPageSize })
        .then((res) => {
          const rows = (res && res.rows) || (res && res.data && res.data.rows) || [];
          const total = (res && res.total) || (res && res.data && res.data.total) || 0;
          this.followList = rows;
          this.followTotal = total;
          this.followLoading = false;
        })
        .catch(() => {
          this.followLoading = false;
        });
    },
    onFollowPage(page) {
      this.followPageNum = page;
      this.loadFollowLog();
    },
  },
};
</script>

<style lang="scss" scoped>
.zhaogu-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 20px;
    border-bottom: 2px solid #347caf;
    margin-bottom: 20px;
  }
}

.follow-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 16px;
  margin-bottom: 8px;
  background: #f5f9fd;
  border: 1px solid #d6e6f5;
  border-radius: 6px;

  .follow-bar-left {
    flex: 1 1 420px;
    min-width: 0;
  }

  .follow-bar-title {
    font-size: 15px;
    font-weight: bold;
    color: #347caf;
    margin-bottom: 4px;

    i {
      margin-right: 5px;
    }

    .el-tag {
      margin-left: 6px;
      vertical-align: middle;
    }
  }

  .follow-bar-desc {
    font-size: 12px;
    color: #7a8b99;
    line-height: 19px;

    b {
      color: #347caf;
      padding: 0 2px;
    }
  }

  .follow-bar-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
}

.follow-tip {
  font-size: 12px;
  color: #7a8b99;
  line-height: 20px;
  margin-bottom: 10px;
}

.txt-muted {
  color: #b6c2cc;
}

.zhaogu-tabs {
  margin-top: 10px;
}

.fenye {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
